export default __webpack_public_path__ + "static/media/icon.21170398.png";